// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';
import Theme from './theme';

const Divider = () => <StyledHorizontalRule />;

const StyledHorizontalRule: StyledComponent<*, *, *> = styled.hr`
  margin: 0;
  border: 1px solid ${Theme.default.color};
`;

export default Divider;
